import { CommonModule } from '@angular/common';
import { ErrorHandler, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { PhdsoftErrorService } from './services/phdsoft-error.service';
import { StorageModule } from '@ngx-pwa/local-storage';
import { DBConfig, NgxIndexedDBModule, ObjectStoreSchema } from 'ngx-indexed-db';

const DBversion = 10372;

// Ahead of time compiles requires an exported function for factories
export function migrationFactory() {
  return {
    // 10368: (db, transaction) => {
    //   let store = transaction.objectStore('background_sync');
    //   store.deleteObjectStore()
    //   // store = transaction.objectStore('undefined');
    //   // store.delete();

    //   // store = transaction.objectStore('cache');
    //   // store.delete();

    //   // store = transaction.objectStore('background');
    //   // store.delete();
    // },
    // 10369: (db, transaction) => {
    //   let store = transaction.objectStore('offline_changes');
    //   store.deleteObjectStore()
    // }
    // 10371: (db, transaction) => {
    //   if (!db.objectStoreNames.contains('offline_changes')) {
    //     let store = transaction.objectStore('offline_changes');
    //     store.createIndex('file', 'file', { unique: false });
    //   }
    // }
    10372: (db, transaction) => {
      if (!db.objectStoreNames.contains('photo_content')) {
        db.createObjectStore('photo_content', { keyPath: null, autoIncrement: false });
      }
      if (!db.objectStoreNames.contains('photo_metadata')) {
        const store = db.createObjectStore('photo_metadata', { keyPath: 'id', autoIncrement: false });
        store.createIndex('assetId', 'assetId', { unique: false });
        store.createIndex('regionIds', 'regionIds', { unique: false });
      }
      if (!db.objectStoreNames.contains('pending_photo_uploads')) {
        db.createObjectStore('pending_photo_uploads', { keyPath: 'tmpId', autoIncrement: false });
      }
    }
  };
}

const storeSchemaDb: ObjectStoreSchema[] = [
  { name: 'key', keypath: 'key', options: { unique: false } },
  { name: 'json', keypath: 'json', options: { unique: false } },
  { name: 'userId', keypath: 'userId', options: { unique: false } },
  { name: 'crypt', keypath: 'crypt', options: { unique: false } },
  { name: 'retry', keypath: 'retry', options: { unique: false, } }
];

const offlineChangesSchemaDb: ObjectStoreSchema[] = [
  { name: 'element', keypath: 'element', options: { unique: false } },
  { name: 'url', keypath: 'url', options: { unique: false} },
  { name: 'method', keypath: 'method', options: { unique: false} },
  { name: 'parameters', keypath: 'parameters', options: { unique: false} },
  { name: 'file', keypath: 'file', options: { unique: false} },
]

const backgroundSyncSchemaDb: ObjectStoreSchema[] = [
  { name: 'element', keypath: 'element', options: { unique: false } },
  { name: 'url', keypath: 'url', options: { unique: false} },
  { name: 'method', keypath: 'method', options: { unique: false} },
  { name: 'parameters', keypath: 'parameters', options: { unique: false} },
  { name: 'file', keypath: 'file', options: { unique: false} },
]

const storeConfigDb = { keyPath: 'id', autoIncrement: true };

export const dbConfig: DBConfig = {
  name: 'PhDsoft_Offline',
  version: DBversion,
  objectStoresMeta: [
    {
      store: 'offline',
      storeConfig: storeConfigDb,
      storeSchema: storeSchemaDb,
    },
    {
      store: 'offline_changes',
      storeConfig: storeConfigDb,
      storeSchema: offlineChangesSchemaDb,
    },
    {
      store: 'background_sync',
      storeConfig: storeConfigDb,
      storeSchema: offlineChangesSchemaDb,
    },

    // #region Photos
    {
      store: 'photo_content',
      storeConfig: { keyPath: null, autoIncrement: false }, // keyPath is not used for this store. We store the content directly in the store
      storeSchema: []
    },
    {
      store: 'photo_metadata',
      storeConfig: { keyPath: 'id', autoIncrement: false },
      storeSchema: [
        // Only fields that are used for querying are necessary here
        { name: 'assetId', keypath: 'assetId', options: { unique: false } },
        { name: 'regionIds', keypath: 'regionIds', options: { unique: false } }
      ]
    },
    {
      store: 'pending_photo_uploads',
      storeConfig: { keyPath: 'tmpId', autoIncrement: false },
      storeSchema: []
    }
    // #endregion
  ],
  migrationFactory
};

@NgModule({
  imports: [
    CommonModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    StorageModule.forRoot({
      IDBDBName: 'PhDsoft_Cache',
      LSPrefix: 'C4D_',
      IDBDBVersion: DBversion,
      IDBStoreName: 'cache'
    }),
  ],
  exports: [],
  declarations: [],
  providers: [],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {

    return {
      ngModule: SharedModule,
      providers: [
        // SignalRService,
        // StorageService,
        // OfflineService,
        // IndexedDbCacheService,
        { provide: LOCALE_ID, useValue: 'en-US' },
        { provide: ErrorHandler, useClass: PhdsoftErrorService },
      ],
    };
  }
}
